import {ACCOUNT_MANAGER, TRANSACTIONS, USER_PROFILE} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/terms'
import {endpoint as endpointText} from '../../../common/text'
import {push} from 'react-router-redux'
import {ApiError} from '../../activity/schemas'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class terms {
  static getTCDeposit(token) {
    return function(dispatch) {
      dispatch({ type: types.GET_DEPOSIT_GUID_REQUEST })
      return apiPrivate.get(TRANSACTIONS + '/operation/deposit/token/' + token)
        .then(response => {
          const deposit = response.data.description
          dispatch(terms.getTCDepositSuccess(deposit))
        }, error => {
          let message = endpointText.somethingWentWrong
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(terms.getTCDepositFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            if (response.description) message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(terms.getTCDepositFail(message))
        })
    }
  }

  static getTCDepositSuccess(deposit) {
    return {
      type: types.GET_DEPOSIT_GUID_SUCCESS,
      payload: {
        deposit
      },
    }
  }

  static getTCDepositFail(error) {
    return {
      type: types.GET_DEPOSIT_GUID_FAILURE,
      payload: {
        error,
      },
    }
  }

  static verifyEmail(token) {
    return function(dispatch) {

      dispatch({type: types.VERIFY_EMAIL_REQUEST })

      return apiPrivate.put(USER_PROFILE + `/user/token/${token}/email/verify`)
        .then(response => {
          const {accepted} = response.data.description
          dispatch(terms.verifyEmailSuccess(accepted !== ''))
        }, error => {
          let message = endpointText.somethingWentWrong
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(terms.verifyEmailFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            if (response.description) message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(terms.verifyEmailFail(message))
        })
    }
  }

  static verifyEmailSuccess(accepted) {
    return {
      type: types.VERIFY_EMAIL_SUCCESS,
      payload: {
        accepted
      },
    }
  }

  static verifyEmailFail(error) {
    return {
      type: types.VERIFY_EMAIL_FAILURE,
      payload: {
        error,
      },
    }
  }

  static acceptTC(token) {
    return function(dispatch) {

      dispatch({type: types.ACCEPT_TYC_REQUEST})

      return apiPrivate.put(ACCOUNT_MANAGER + `/tyc/token/${token}/accept`)
        .then(response => {
          dispatch(terms.acceptTCSuccess())
        }, error => {
          let message = endpointText.somethingWentWrong
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(terms.acceptTCFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            if (response.description) message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(terms.acceptTCFail(message))
        })
    }
  }

  static acceptTCSuccess() {
    return {
      type: types.ACCEPT_TYC_SUCCESS,
    }
  }

  static acceptTCFail(error) {
    return {
      type: types.ACCEPT_TYC_FAILURE,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/termsDeposit/actions/terms.js